import { paths } from '~/__generated__/botco-api-schema';
import {
  ExtractPathParamsFromPath,
  ExtractRequestBodyFromPath,
} from '~/types/open-api-helpers';

import { axiosClient } from '../axiosClient';
import { Intent } from './types';

type PathUrl = paths['/agents/{agentId}/intents']['post'];
type UrlParams = ExtractPathParamsFromPath<PathUrl>;
type Body = ExtractRequestBodyFromPath<PathUrl>;

type Options = {
  params: UrlParams;
  body: Body;
};

export const createAgentIntent = ({ params, body }: Options) => {
  return axiosClient.post<Intent>(`/agents/${params.agentId}/intents`, body);
};
